export const validOrderedListTypeValues = ['decimal', 'lower-alpha', 'none'];
export const validUnorderedListTypeValues = ['disc', 'circle', 'none'];
export const validListPositionValues = ['inside', 'outside'];
export const isValidSpacing = value => value || value === 0;
export const validComponentValues = ['p', 'em', 'strong', 'div', 'span', 'li', 'blockquote'];
export const validAlignValues = ['left', 'center', 'right', 'start', 'end'];
export const validWeightValues = ['bold', 'normal'];